<template>
  <div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
    >
      <el-form-item prop="telephone">
        <el-input
          v-model="ruleForm.telephone"
          clearable
          placeholder="请输入手机号"
        >
          <i slot="prefix" class="el-input__icon el-icon-phone-outline"> </i>
        </el-input>
      </el-form-item>

      <el-form-item prop="message">
        <el-input
          :maxlength="6"
          v-model="ruleForm.code"
          placeholder="请输入短信验证码"
        >
          <i slot="prefix" class="el-input__icon el-icon-message"> </i>
        </el-input>
        <el-link
          :underline="false"
          type="success"
          v-if="codeState == 1"
          @click="getSMSCode(1)"
          >发送验证码</el-link
        >
        <el-link
          :underline="false"
          type="success"
          v-if="codeState == 2"
          @click="getSMSCode(2)"
          >{{ second }}s后重新发送
        </el-link>
      </el-form-item>

      <el-form-item class="form_item_btn">
        <el-button class="btn_submit" type="success" @click="submitForm"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from "@/util/index";
import {
  doLogin,
  sendSms,
  unmatched,
  getUserMsg,
  getUserInfoByTel,
} from "@/network/loginRequest/api";
export default {
  data() {
    return {
      ruleForm: {
        telephone: "",
        code: "",
      },
      second: 60,
      codeState: 1, // 1--未发送，2--已发送
    };
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let form = this.ruleForm;

          if (form.telephone == "") {
            utils.tips("warning", "请输入手机号");
            return false;
          }

          if (form.code == "") {
            utils.tips("warning", "请输入验证码");
            return false;
          }

          var fd = new FormData();
          fd.append("vCode", form.code);
          fd.append("telephone", form.telephone);
          fd.append("account", form.telephone);
          fd.append("type", "0");

          doLogin(fd)
            .then((res) => {
              let response = res.data.data;

              if (res.data.success) {
                //登录成功
                //修改vuex的登录状态
                this.$store.commit("isLogin", true);
                //修改用户id
                this.$store.commit("setUserId", response.sessionUser.userId);
                //修改用户信息--------------------------------------------
                this.$store.commit("setUser", response.sessionUser);
                //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
                utils.setSess("store", JSON.stringify(this.$store.state));
                //保存token到sessionStorage
                utils.setSess("loginMessage", response.token);
                //将验证保存到sessionStorage
                utils.setSess("Authorazition", res.headers.authorazition);
                console.log("登录===mfromInput", this.$bus.loginChecked);
                // 登录成功把token储存到Cookie中
                if (this.$bus.loginChecked) {
                  //保存1天
                  utils.setCookie(
                    "loginMessage",
                    response.token,
                    1 * 24 * 60 * 60 * 1000
                  );

                  utils.setCookie(
                    "userId",
                    response.sessionUser.userId,
                    1 * 24 * 60 * 60 * 1000
                  );

                  utils.setCookie(
                    "user",
                    response.sessionUser,
                    1 * 24 * 60 * 60 * 1000
                  );

                  utils.setCookie(
                    "Authorazition",
                    res.headers.authorazition,
                    1 * 24 * 60 * 60 * 1000
                  );
                } else {
                  utils.clearCookie("loginMessage");
                  utils.clearCookie("userId");
                  utils.clearCookie("Authorazition");
                }

                this.$router.push({
                  name: "ResourceCenter",
                });
              } else {
                utils.tips("warning", res.data.code);
              }
            })
            .catch((err) => {
              utils.tips("error", "请求失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getSMSCode(type) {
      let RegPhone = new RegExp(
        /^1([3589][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      ); //验证手机号
      var tel = this.ruleForm.telephone;

      if (tel == "") {
        utils.tips("warning", "请输入手机号码");
        return false;
      }
      if (!RegPhone.test(tel)) {
        utils.tips("warning", "请输入正确的手机号码");
        return false;
      }

      if (type == 1) {
        getUserInfoByTel(tel).then((res) => {
          if (res.data.state == 2) {
            utils.tips("warning", "该手机号尚未注册过，请您注册");
            return false;
            //发送验证码
          } else if (res.data.state == 1) {
            sendSms(tel)
              .then((res) => {
                if (res.data.state == "1") {
                  utils.tips("success", "发送成功！");
                  this.codeState = 2;
                  let that = this;
                  let t = setInterval(() => {
                    if (this.second == 0) {
                      that.second = 60;
                      clearInterval(t);
                      this.codeState = 1;
                    } else {
                      that.second = that.second - 1;
                    }
                  }, 1000);
                } else {
                  utils.tips("info", res.data.code);
                }
              })
              .catch((err) => {
                utils.tips("error", err);
              });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .form_item_btn {
    margin-top: 10px;
  }

  .el-form-item:nth-child(3) {
    margin-bottom: 10px;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 30px;

    .el-form-item__content {
      position: relative;

      .el-link {
        position: absolute;
        top: 0;
        right: 5px;
      }
    }

    .btn_submit {
      width: 100%;
      background-color: #24ba58;
      border-color: #24ba58;
    }

    .el-button--success:active {
      background-color: skyblue;
      border-color: skyblue;
    }

    /deep/.el-input__inner:focus {
      border-color: #24ba58;
    }
  }
}
</style>
